import React from "react";
import Payrollbanner from "../../AVHRBanner/PayrollBanner.png";
// import payrolloneimg from "../../Images/Payrolloneimg.png";
import payrolloneimg from "../../Images/Payrollimg.png";
import "../OurServicesCss/Services.css";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { FaCogs, FaChartLine, FaBalanceScale, FaCheckCircle } from "react-icons/fa";

function Payroll() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={Payrollbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">Our Services</p>

              <h1 className="career-library-heading">Payroll Management</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>



        <div className="grid align-items-center px-3 md:px-6 pt-4 md:pt-6">
          <div className="col-12 md:col-6">

            {/* Customized Solutions */}
            <h3 className="avhrProject-h3">
              {/* <FaCogs className="circelcolour text-4xl mr-2" /> */}
              <span className="text-4xl mr-2">🛠️</span>
              Customized Solutions
            </h3>
            <ul className="avhrProject-p pl-2">
              <li className="flex items-start mb-2">
                {/* <FaCheckCircle className="mr-2 mt-1 circelcolour text-lg" /> */}
                <span>
                  <b>Customized Payroll Services:</b> Our payroll services are flexible and can be tailored to match your specific business needs. As your business evolves, we scale up accordingly.
                   we can do the upscaling accordingly. We automate complex payroll computations, making payroll administration a seamless process
                </span>
              </li>
            </ul>

            {/* Operational Efficiency */}
            <h3 className="avhrProject-h3 mt-6">
              {/* <FaChartLine className="circelcolour text-4xl mr-2" /> */}
              <span className="text-4xl mr-2">📈</span>
              Operational Efficiency
            </h3>
            <ul className="avhrProject-p pl-2">
              <li className="flex items-start mb-2">
                {/* <FaCheckCircle className="mr-2 mt-1 circelcolour text-lg" /> */}
                <span>
                  <b>Streamlined Payroll Calculations:</b> We automate complex payroll
                   computations, simplifying payroll administration into a smooth, hassle-free process
                </span>
              </li>
            </ul>

            {/* Regulatory Compliance */}
            <h3 className="avhrProject-h3 mt-6">
              {/* <FaBalanceScale className="circelcolour text-4xl mr-2" /> */}
              <span className="text-4xl mr-2">⚖️</span>
              Regulatory Compliance
            </h3>
            <ul className="avhrProject-p pl-2">
              <li className="flex items-start mb-2">
                {/* <FaCheckCircle className="mr-2 mt-1 circelcolour text-lg" /> */}
                <span>
                  <b>Adherence to Tax Regulations:</b> We keep your payroll operations 
                  aligned with tax regulations, helping you avoid costly penalties and legal issues.
                   We also generate the required reports to keep your business compliant
                </span>
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="col-12 md:col-6 mb-4 md:mb-0">
            <img
              src={payrolloneimg}
              alt="payroll"
              className="w-full border-round-lg shadow-4"
            />
          </div>
        </div>



        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(-120deg, #FFA94D, #FFE766)",
            }}>
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2 ">
              We help you become your enhanced BEST
              <br/>
               Connect with us right away
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default Payroll;
